import { render, staticRenderFns } from "./Mini_StudyPlan.vue?vue&type=template&id=4823c728&scoped=true&"
import script from "./Mini_StudyPlan.vue?vue&type=script&lang=js&"
export * from "./Mini_StudyPlan.vue?vue&type=script&lang=js&"
import style0 from "./Mini_StudyPlan.vue?vue&type=style&index=0&id=4823c728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4823c728",
  null
  
)

export default component.exports